<template>
    <div class="apprentice-simple-card logbook">
        <div class="log-time-list" v-if="logs.length > 0">
            <design-2021-log-time-list-component :log-items-by-time="logsByTimeIn" :paper-id="projectIn.id" @row-clicked="rowClicked"></design-2021-log-time-list-component>
        </div>
        <design-2021-log-data-table-component
            :log-data="logsIn"
            :project-in="projectIn"
            :user-id="userId"
            :search-in="selectedStudentName"
        ></design-2021-log-data-table-component>

        <design-2021-log-apex-component :series-in="logbookDataSeries"
                                        v-if="logsIn.length > 0">
        </design-2021-log-apex-component>
    </div>
</template>

<script>
    import moment from "moment";
    import {LogBus} from "../../../app";

    export default {
        name: "design-2021-project-show-logbook-component",
        props: ['logsIn', 'logsByTimeIn', 'userId', 'projectIn'],
        data() {
            return {
                logs: this.logsIn,
                authId: this.$AuthId,
                selectedRow: null,
            }
        },
        created(){
            LogBus.$on('pushData', (id) => {
               this.logs = this.logs.filter(log => log.id !== id);
            });
        },
        methods:{
            rowClicked(row) {
                this.selectedRow = row;
            },
            getData(logItem, previousTime){
                let previousTimeSplit = previousTime.split(',');
                let totalHours = parseInt(previousTimeSplit[0]);

                let totalMinutes = parseInt(previousTimeSplit[1]);

                let differences = null;
                let logSplit = logItem.difference.split(' ');


                if(logSplit.length === 4){
                    totalMinutes = totalMinutes + parseInt(logSplit[2]);
                    totalHours = totalHours + parseInt(logSplit[0]);

                    if(totalMinutes > 60){
                        totalHours = totalHours + 1;
                        totalMinutes = totalMinutes - 60;
                    }

                    differences = totalHours + ' uur, ' + totalMinutes + ' min';
                }
                else{
                    if(logSplit[1] === 'min'){
                        totalMinutes = totalMinutes + parseInt(logSplit[0]);

                        if(totalMinutes > 60){
                            totalHours = totalHours + 1;
                            totalMinutes = totalMinutes - 60;
                        }
                    }
                    else{
                        totalHours = totalHours + parseInt(logSplit[0]);
                    }

                    differences = totalHours + this.$t('project.hour');
                }

                return totalHours + ',' + totalMinutes;
            },
        },
        computed: {
            selectedStudentName(){
                return this.selectedRow ? this.selectedRow.name : null;
            },
            logbookDataSeries(){
                const logs = this.logs.sort((a,b) => {
                    return new Date(a.date_time) - new Date(b.date_time);
                });

                const logbookItems = [... new Set(logs.map(log => log.name))];
                const series = logbookItems.map(item => {
                    let data = [[moment(String(logs[0].date_time)).subtract(1, 'day').format('YYYY-MM-DD h:mm:ss'),0]];

                    let totalTime = '0,0';
                    for(const logbook of logs){
                        if(logbook.name === item){
                            totalTime = this.getData(logbook, totalTime)
                            let totalTimeSplit = totalTime.split(',');
                            let totalHours = parseInt(totalTimeSplit[0]);
                            let totalMinutes = parseInt(totalTimeSplit[1]);
                            totalMinutes = totalMinutes / 60;
                            const total = totalHours + totalMinutes;
                            data.push([logbook.date_time, total.toFixed(1)]);
                        }
                    }
                    return {
                        name: item,
                        data: [...data]
                    }
                })
                return series;
            },
        }
    }
</script>

<style scoped lang="scss">
    .logbook {
        .apprentice-simple-card{
            padding: 0;
        }
    }
</style>
